import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import Typography from '@/modules/components/Typography'

import { LearnSec } from '../../data'
import { LearnCategory } from './LearnCategory'

export const LearnMenu = ({
  learnSec,
  onClickMenuLink,
}: {
  learnSec: LearnSec[]
  onClickMenuLink: () => void
}) => {
  const { t } = useTranslation('navigation')
  return (
    <Box px={5}>
      {learnSec.map(({ tTitle, items }, i) => {
        return (
          <Box key={tTitle}>
            <Flex pt={4} pb={'12px'} mr={3}>
              {tTitle && (
                <Typography
                  variant="h5"
                  color="secondaryDarkGrey"
                  flex={[1 / items.length + 1]}
                  minWidth={['208px']}
                  maxWidth={['338px']}
                >
                  {t(tTitle)}
                </Typography>
              )}
              <Flex flexWrap="wrap" width="516px">
                {items.map(({ tTitle, tDesc, href }) => (
                  <Box key={tTitle} width="50%">
                    <LearnCategory
                      href={href}
                      tTitle={tTitle}
                      tDesc={tDesc}
                      translateFn={t}
                      onClick={onClickMenuLink}
                    />
                  </Box>
                ))}
              </Flex>
            </Flex>
            {i !== learnSec.length - 1 && (
              <Box height={0.5} bg="secondaryDarkGrey" />
            )}
          </Box>
        )
      })}
    </Box>
  )
}
